import React from "react";
import { InputAdornment, TextField } from "@mui/material";
import { styled } from "@mui/system";
const CustomTextField = styled(TextField)`
  .icon {
    margin-right: ${({ theme }) => theme.spacing(1)};
  }
`;
const CustomDateInput = ({
  icon,
  placeholder,
  Value,
  iconClick,
  disabled,
  isPast,
  color,
  placeholderColor
}) => {
  const today = new Date().toISOString().split("T")[0];
  return (
    <CustomTextField
      placeholder={placeholder}
      disabled={disabled}
      sx={{
        "& .MuiOutlinedInput-root": {
          height: "48px",
          fontFamily: "PoppinsMedium",
          fontSize:  "clamp(10px, 4vw, 13px)",
          color: color ? color : "#FFF",
          backgroundColor: "transparent",
          borderRadius: "11px",
          colorScheme: "dark",
        },   
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#666666", 
        },
        "& .MuiInputBase-input": {
          textTransform:  "capitalize",
        },
        "& input::placeholder": {
          color: placeholderColor ? placeholderColor : "#8A8A8A",
        },
        "& .MuiInputBase-input::placeholder": {
          color: placeholderColor ? placeholderColor : "#8A8A8A",
          opacity: 1
        },
        "& .MuiInputBase-input.Mui-disabled": {
          WebkitTextFillColor: "#ccc",
        },
      }}
      value={Value}
      onWheel={(e) => e.target.blur()}
      autoComplete={"off"}
      min={isPast ? today : undefined}
      InputProps={{
        endAdornment: icon ? (
          <InputAdornment position="end">
            <button
              onClick={iconClick}
              className="btn btn-0 border-0 ButtonFoucusNone"
            >
              {icon && (
                <span
                  className="icon text-center mx-auto"
                  style={{ color:  "#000" }}
                >
                  {icon}
                </span>
              )}
            </button>
          </InputAdornment>
        ) : (
          ""
        ),
 
      }}
      
    />
  );
};

export default CustomDateInput;
